module.exports = __webpack_public_path__ + "static/img/ys2.5d19364.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/control2/ys2.png
// module id = 0KG8
// module chunks = 7